var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ws-wrapper',{class:{
    'ws-icon ws-icon__wrapper flex items-center': _vm.wrap,
    circle: _vm.circle,
    [_vm.bgColorClass]: _vm.bgColor,
  },style:(_vm.sizes),attrs:{"wrap":_vm.wrap}},[_c(_vm.unloaded ? 'span' : 'inline-svg',_vm._g(_vm._b({tag:"component",class:_vm.classes,style:(_vm.sizes),attrs:{"src":_vm.iconUrl,"title":_vm.name,"circle":_vm.circle}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._v(" □ ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }